import { render } from "./studied_english.vue?vue&type=template&id=1dcaef9e&ts=true"
import script from "./studied_english.vue?vue&type=script&lang=ts"
export * from "./studied_english.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__